<script setup>

import {usePage} from "@inertiajs/vue3";
import FeatureBlocker from "../FeatureBlocker.vue";

defineProps({
    theme: Object,
    name: String,
    icon: String,
    feature: String
})

</script>

<template>
    <FeatureBlocker :name="feature" version="Pro" inline>
    <div class="flex gap-2 bg-gray-50 dark:border-neutral-700 dark:bg-black rounded-lg items-center border py-3 px-4 ">
        <i :class="icon"></i>
        <label class="grow">{{name}}</label>
        <slot v-if="theme?.darkMode" name="dark"></slot>
        <slot v-else name="light"></slot>
        <slot name="default"></slot>
    </div>
    </FeatureBlocker>
</template>

<style scoped lang="scss">

</style>
